import Modal from '@resources/js/ui/Modal';
import Tabs from '@resources/js/ui/Tabs';
const languageModalElement = document.querySelector('.js-lang-currency-modal');
if (languageModalElement) {
    new Modal(languageModalElement, {
        trigger: '.js-lang-currency-modal-open',
        selectors: {
            close: '.js-lang-currency-modal-close',
            content: '.js-lang-currency-modal-content',
        },
    });
    const tabs = new Tabs(languageModalElement);
    if (tabs.items.length)
        tabs.openIndex(0);
}
